import React, { useState, useEffect } from 'react'
import { FiArrowLeft, FiUpload, FiTrash2, FiZoomIn, FiZoomOut, FiEye, FiGrid, FiThumbsUp, FiThumbsDown } from 'react-icons/fi'
import { Document, Page, pdfjs } from "react-pdf"
import { toast } from 'react-toastify'
import "react-pdf/dist/Page/AnnotationLayer.css"
import "react-pdf/dist/Page/TextLayer.css"
import './CatalogoDetalle.css'
import { SelectionArea } from './SelectionArea'
import { 
  postTraductorRepuestos, 
  getCatalogoInfoByPath, 
  getItemsByCatalogoId,
  getIam,
  getMarcas,
  postSugerirJerarquiaLote,
  postSugerirGrupoArticuloLote,
  postCrearItems,
  postFiltrarNuevosItems,
  getGruposArticulos,
  postSubirImagenItem,
} from '../../../services/axiomaService'

// Configure PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`

// Opciones de PDF.js para cargar fuentes y mapas de caracteres correctamente
const pdfjsOptions = {
  cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
  cMapPacked: true,
  standardFontDataUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/standard_fonts/`,
}

const CatalogoDetalle = ({ catalogo, nombreProveedor: proveedorData, onVolver, idUser }) => {
  const nombreProveedor = typeof proveedorData === 'string' 
    ? proveedorData 
    : (proveedorData?.nombre_proveedor || proveedorData?.nombre || '')
  const codigoProveedor = typeof proveedorData === 'object' 
    ? (proveedorData?.codigo_proveedor || '') 
    : ''
  const [imagenes, setImagenes] = useState([])
  const [instrucciones, setInstrucciones] = useState('')
  const [numPages, setNumPages] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const [scale, setScale] = useState(1.2)
  const [previewImage, setPreviewImage] = useState(null)
  const [showThumbnails, setShowThumbnails] = useState(false)
  const [pageInput, setPageInput] = useState('')
  const [showTableModal, setShowTableModal] = useState(false)
  const [tableData, setTableData] = useState([])
  const [tableHeaders, setTableHeaders] = useState([])
  const [tableDataOriginal, setTableDataOriginal] = useState([])
  const [materiales, setMateriales] = useState([])
  const [loadingMateriales, setLoadingMateriales] = useState(false)
  const [catalogoId, setCatalogoId] = useState(null)
  const [userId, setUserId] = useState(idUser || null)
  
  // States para el modal de marcas
  const [showMarcasModal, setShowMarcasModal] = useState(false)
  const [marcas, setMarcas] = useState([])
  const [marcaSeleccionada, setMarcaSeleccionada] = useState(null)
  const [loadingMarcas, setLoadingMarcas] = useState(false)
  
  // States para grupos de artículos
  const [gruposArticulos, setGruposArticulos] = useState([])
  const [loadingGrupos, setLoadingGrupos] = useState(false)
  
  // State para guardar la lista de gs_urls de las imágenes subidas (capturas de traducción)
  const [gsUrlsImagenes, setGsUrlsImagenes] = useState([])
  
  // States para el modal de confirmación de materiales existentes
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [materialesExistentes, setMaterialesExistentes] = useState(0)
  const [materialesNuevos, setMaterialesNuevos] = useState(0)
  const [itemsFiltrados, setItemsFiltrados] = useState([])
  const [npfExistentes, setNpfExistentes] = useState([])
  const [catalogoInfoData, setCatalogoInfoData] = useState(null)

  /** Metadata por fila: { [rowId]: { categoria_snapshot, subcategoria_snapshot, estructura_original } } */
  const [rowMetadata, setRowMetadata] = useState({})

  // Cargar los materiales del catálogo
  useEffect(() => {
    const cargarMateriales = async () => {
      if (!catalogo || !catalogo.path) return

      setLoadingMateriales(true)
      try {
        // Paso 1: Obtener la información del catálogo por su path
        const catalogoInfo = await getCatalogoInfoByPath(catalogo.path)
        
        if (catalogoInfo && catalogoInfo.success && catalogoInfo.success.id) {
          const idCatalogo = catalogoInfo.success.id
          setCatalogoId(idCatalogo) 
          setCatalogoInfoData(catalogoInfo.success)
          // Paso 2: Obtener los items del catálogo usando el ID
          const itemsResponse = await getItemsByCatalogoId(idCatalogo)
          
          if (itemsResponse && itemsResponse.items) {
            setMateriales(itemsResponse.items)
          } else {
            toast.error('No se pudieron cargar los materiales del catálogo')
          }
        } else {
          toast.error('No se pudo obtener la información del catálogo')
        }
      } catch (error) {
        console.error('Error al cargar materiales:', error)
        toast.error('Error al cargar los materiales')
      } finally {
        setLoadingMateriales(false)
      }
    }

    cargarMateriales()
  }, [catalogo])

  // Obtener el ID del usuario si no está disponible
  useEffect(() => {
    const fetchUserId = async () => {
      if (!userId) {
        try {
          const response = await getIam()
          if (response && response.id) {
            setUserId(response.id)
          }
        } catch (error) {
          console.error('Error al obtener el usuario:', error)
        }
      }
    }

    fetchUserId()
  }, [userId])

  const handleImagenChange = (e) => {
    const file = e.target.files[0]
    if (file) {
      if (imagenes.length >= 4) {
        toast.warning('Ya están las 4 imágenes. Elimina alguna para agregar otra.')
        return
      }
      const newImage = {
        id: Date.now().toString(),
        file,
        preview: URL.createObjectURL(file),
        timestamp: Date.now(),
      }
      setImagenes((prev) => [...prev, newImage])
    }
  }

  const getNombreArchivo = (path) => {
    if (!path) return 'Sin nombre'
    const partes = path.split('/')
    return partes[partes.length - 1]
  }

  const onDocumentLoadSuccess = (pdf) => {
    setNumPages(pdf.numPages)
  }

  const handleSnippet = (imageData) => {
    if (imagenes.length >= 4) {
      toast.warning('Ya están las 4 imágenes. Elimina alguna para agregar otra.')
      return
    }

    // Convertir el dataURL a un File decodificando el base64 directamente:
    // el CSP de prod bloquea fetch a URLs data:, así que no se puede usar fetch(imageData)
    try {
      const [header, base64] = imageData.split(',')
      const mime = header.match(/:(.*?);/)[1]
      const binario = atob(base64)
      const bytes = new Uint8Array(binario.length)
      for (let i = 0; i < binario.length; i++) bytes[i] = binario.charCodeAt(i)
      const blob = new Blob([bytes], { type: mime })
      const file = new File([blob], `captura-${Date.now()}.png`, { type: 'image/png' })
      const newImage = {
        id: Date.now().toString(),
        file,
        preview: imageData,
        timestamp: Date.now(),
        isScreenshot: true,
      }
      setImagenes((prev) => [...prev, newImage])
    } catch (error) {
      console.error('Error al procesar el recorte:', error)
      toast.error('No se pudo procesar el recorte. Intenta de nuevo.')
    }
  }

  const deleteImagen = (id) => {
    setImagenes((prev) => {
      const imagen = prev.find(img => img.id === id)
      if (imagen && imagen.preview) {
        URL.revokeObjectURL(imagen.preview)
      }
      return prev.filter((img) => img.id !== id)
    })
  }

  const previewImagen = (imagen) => {
    setPreviewImage(imagen)
  }

  const closePreview = () => {
    setPreviewImage(null)
  }

  const zoomIn = () => setScale((prev) => Math.min(prev + 0.2, 3))
  const zoomOut = () => setScale((prev) => Math.max(prev - 0.2, 0.6))

  const handlePageInputChange = (e) => {
    const {value} = e.target
    setPageInput(value)
  }

  const handlePageInputSubmit = (e) => {
    e.preventDefault()
    const pageNumber = parseInt(pageInput, 10)
    if (pageNumber >= 1 && pageNumber <= numPages) {
      setCurrentPage(pageNumber)
      setPageInput('')
    } else {
      toast.warning(`Ingresa un número entre 1 y ${numPages}`)
    }
  }

  const goToPage = (pageNum) => {
    setCurrentPage(pageNum)
    setShowThumbnails(false)
  }

  const parseMarkdownTable = (markdownTable) => {
    const lines = markdownTable.trim().split('\n')
    if (lines.length < 3) return { headers: [], rows: [] }

    // Primera línea son los headers
    const headers = lines[0]
      .split('|')
      .map(h => h.trim())
      .filter(h => h !== '')

    // Tercera línea en adelante son los datos (saltamos la línea de separadores)
    const rows = lines.slice(2).map(line => {
      const cells = line
        .split('|')
        .map(c => c.trim())
        .filter(c => c !== '')
      return cells
    })

    return { headers, rows }
  }

  const handleSubmit = async () => {
    if (imagenes.length === 0) {
      toast.warning('Debes agregar al menos una imagen antes de subir.')
      return
    }

    // Cargar marcas y mostrar modal de selección
    setLoadingMarcas(true)
    setShowMarcasModal(true)
    
    try {
      const response = await getMarcas()
      if (response && response.marcas) {
        setMarcas(response.marcas)
      } else {
        toast.error('Error al cargar las marcas')
        setShowMarcasModal(false)
      }
    } catch (error) {
      console.error('Error al cargar marcas:', error)
      toast.error('Error al cargar las marcas')
      setShowMarcasModal(false)
    } finally {
      setLoadingMarcas(false)
    }
  }

  const validarMaterialesExistentes = async (tableDataToValidate, headers) => {
    try {
      // Encontrar el índice de la columna NPF
      const parteNumeroIdx = headers.findIndex(h => 
        h.toLowerCase().includes('nro antiguo') || h.toLowerCase().includes('npf')
      )
      
      if (parteNumeroIdx === -1) {
        return
      }
      
      // Extraer todos los NPF candidatos
      const npfCandidatos = tableDataToValidate
        .map(row => row.cells[parteNumeroIdx])
        .filter(npf => npf && npf.trim() !== '')
      
      if (npfCandidatos.length === 0) {
        return
      }
      
      // Validar NPF
      const respuestaFiltro = await postFiltrarNuevosItems(npfCandidatos)
      
      if (!respuestaFiltro || !Array.isArray(respuestaFiltro)) {
        return
      }
      
      // El endpoint retorna los NPF que SÍ son nuevos (no existen)
      const npfNuevos = respuestaFiltro.map(item => item.npf)
      const totalEnviados = npfCandidatos.length
      const totalNuevos = npfNuevos.length
      const totalExistentes = totalEnviados - totalNuevos
      
      // Calcular los NPF existentes (los que NO están en npfNuevos)
      const npfExistentesCalculados = npfCandidatos.filter(npf => !npfNuevos.includes(npf))
      setNpfExistentes(npfExistentesCalculados)
      
      // Mostrar alert con el resumen
      if (totalExistentes > 0) {
        alert(`Se encontraron ${totalEnviados} resultados. ${totalNuevos} nuevos, ${totalExistentes} existentes.`)
      }
    } catch (error) {
      console.error('Error al validar materiales existentes:', error)
    }
  }

  const handleContinuarConMarca = async () => {
    if (!marcaSeleccionada) {
      toast.warning('Debes seleccionar una marca para continuar.')
      return
    }

    setShowMarcasModal(false)

    try {
      // Subir todas las capturas (screenshots) y recolectar sus gs_urls
      if (imagenes.length > 0) {
        console.log('=== Subiendo todas las capturas ===')
        console.log('Marca seleccionada:', marcaSeleccionada)
        console.log('Proveedor:', nombreProveedor)
        console.log('Total de imágenes:', imagenes.length)

        const resultadosSubida = await Promise.all(
          imagenes.map((imagen) => postSubirImagenItem(imagen, nombreProveedor))
        )
        const gsUrls = resultadosSubida
          .filter((r) => r && r.gs_url)
          .map((r) => r.gs_url)

        if (gsUrls.length > 0) {
          setGsUrlsImagenes(gsUrls)
          console.log('=== gs_urls guardados ===', gsUrls)
          toast.success(`${gsUrls.length} imagen(es) cargada(s) exitosamente`)
        } else {
          toast.warning('No se pudo cargar ninguna imagen')
        }
      }

      const resultado = await postTraductorRepuestos(
        imagenes,
        instrucciones
      )
      
      if (resultado && resultado.traduccion) {
        toast.success('Repuestos traducidos exitosamente')
        console.log('Respuesta del traductor:', resultado)
        console.log('Marca seleccionada:', marcaSeleccionada)
        
        // Parsear la tabla y mostrar el modal
        const { headers, rows } = parseMarkdownTable(resultado.traduccion)
        
        // Encontrar índices de las columnas originales
        const textoBreveEnIdx = headers.findIndex(h => 
          (h.toLowerCase().includes('descripcion') || h.toLowerCase().includes('descripción')) && 
          h.toLowerCase().includes('ingles')
        )
        const npfIdx = headers.findIndex(h => 
          h.toLowerCase().includes('parte') && 
          h.toLowerCase().includes('numero')
        )
        const textoChino = headers.findIndex(h => 
          h.toLowerCase().includes('chino') || 
          h.toLowerCase().includes('idioma original')
        )
        const textoBreveEsIdx = headers.findIndex(h => 
          h.toLowerCase().includes('colombiano') || 
          h.toLowerCase().includes('repuesto') ||
          h.toLowerCase().includes('español')
        )
        const chasisIdx = headers.findIndex(h => 
          h.toLowerCase().includes('sistema') ||
          h.toLowerCase().includes('chasis')
        )
        const precioIdx = headers.findIndex(h => 
          h.toLowerCase().includes('precio')
        )
        
        // Preparar datos para el endpoint de sugerir jerarquía
        const itemsParaJerarquia = rows.map((row, idx) => ({
          id_temporal: `fila-${idx + 1}`,
          marca: marcaSeleccionada,
          descripcion: textoBreveEsIdx !== -1 ? row[textoBreveEsIdx] : (row[1] || '')
        }))
        
        console.log('Items para jerarquía:', itemsParaJerarquia)
        
        // Llamar al endpoint de sugerir jerarquía
        const resultadoJerarquia = await postSugerirJerarquiaLote(itemsParaJerarquia)
        
        if (resultadoJerarquia) {
          console.log('Resultado de sugerir jerarquía:', resultadoJerarquia)
        }
        
        // Llamar al endpoint de sugerir grupo de artículo
        const resultadoGrupoArticulo = await postSugerirGrupoArticuloLote(itemsParaJerarquia)
        
        if (resultadoGrupoArticulo) {
          console.log('Resultado de sugerir grupo de artículo:', resultadoGrupoArticulo)
        }
        
        // Crear mapas de jerarquías y metadata por id_temporal
        const jerarquiaMap = {}
        const jerarquiaMetaMap = {}
        if (resultadoJerarquia && resultadoJerarquia.resultados) {
          resultadoJerarquia.resultados.forEach(item => {
            let jerarquia = item.jerarquia_concatenada_sugerida || ''
            
            if (!jerarquia && item.sugerencias && item.sugerencias.length > 0) {
              jerarquia = item.sugerencias[0].Jerarquia_Concatenada || ''
            }
            
            jerarquiaMap[item.id_temporal] = jerarquia
            jerarquiaMetaMap[item.id_temporal] = {
              estructura_sugerida: item.estructura_sugerida || '',
              categoria_sugerida: item.categoria_sugerida || '',
              subcategoria_sugerida: item.subcategoria_sugerida || '',
            }
          })
        }
        
        // Crear un mapa de grupos de artículo por id_temporal
        const grupoArticuloMap = {}
        if (resultadoGrupoArticulo && resultadoGrupoArticulo.resultados) {
          resultadoGrupoArticulo.resultados.forEach(item => {
            let grupoArticulo = ''
            
            // Obtener el grupo de artículo de la primera sugerencia (mejor coincidencia)
            // El campo correcto es "Grupo_articulo_predicho" según la respuesta del API
            if (item.sugerencias && item.sugerencias.length > 0) {
              grupoArticulo = item.sugerencias[0].Grupo_articulo_predicho || 
                            item.sugerencias[0].grupo_articulo_predicho || 
                            item.sugerencias[0].Grupo_Articulo_Predicho || ''
            }
            
            // Si no está en las sugerencias, intentar obtenerlo directamente del objeto
            if (!grupoArticulo) {
              grupoArticulo = item.grupo_articulo || 
                            item.Grupo_Articulo || 
                            item.grupo_articulo_sugerido ||
                            item.Grupo_Articulo_Sugerido || ''
            }
            
            grupoArticuloMap[item.id_temporal] = grupoArticulo
          })
        }
        
        // Definir los headers en el nuevo orden y con nombres en mayúsculas
        const headersConNuevasColumnas = [
          'SISTEMA DE LA MOTO',
          'TEXTO BREVE',
          'GRUPO DE ARTICULO',
          'NRO ANTIGUO DE MATERIAL (NPF)',
          'TEXTO BREVE EN INGLES',
          'TEXTO EN CHINO',
          'MOTIVO',
          'JERARQUIA',
          'ESTRUCTURA SUGERIDA',
          'CALIFICACION',
          'FOB',
          'CANTIDAD'
        ]
        
        // Reordenar las columnas según el nuevo orden
        const rowsConNuevasColumnas = rows.map((row, idx) => {
          const idTemporal = `fila-${idx + 1}`
          const jerarquia = jerarquiaMap[idTemporal] || ''
          const grupoArticulo = grupoArticuloMap[idTemporal] || ''
          const meta = jerarquiaMetaMap[idTemporal] || {}
          
          return [
            chasisIdx !== -1 ? row[chasisIdx] : '',                    // SISTEMA DE LA MOTO
            textoBreveEsIdx !== -1 ? row[textoBreveEsIdx] : '',        // TEXTO BREVE
            grupoArticulo,                                              // GRUPO DE ARTICULO (sugerido)
            npfIdx !== -1 ? row[npfIdx] : '',                          // NRO ANTIGUO DE MATERIAL (NPF)
            textoBreveEnIdx !== -1 ? row[textoBreveEnIdx] : '',        // TEXTO BREVE EN INGLES
            textoChino !== -1 ? row[textoChino] : '',                  // TEXTO EN CHINO
            'NUEVA REFERENCIA',                                          // MOTIVO
            jerarquia,                                                   // JERARQUIA
            meta.estructura_sugerida || '',                              // ESTRUCTURA SUGERIDA
            '',                                                          // CALIFICACION (vacía inicialmente)
            precioIdx !== -1 ? row[precioIdx] : '',                      // FOB (desde precio)
            '0'                                                          // CANTIDAD (inicia en 0)
          ]
        })
        
        // Construir metadata por fila (datos no editables para enviar al guardar)
        const metadata = {}
        rowsConNuevasColumnas.forEach((row, idx) => {
          const idTemporal = `fila-${idx + 1}`
          const meta = jerarquiaMetaMap[idTemporal] || {}
          metadata[idx] = {
            categoria_snapshot: meta.categoria_sugerida || '',
            subcategoria_snapshot: meta.subcategoria_sugerida || '',
            estructura_original: meta.estructura_sugerida || '',
          }
        })
        setRowMetadata(metadata)
        
        const dataConIds = rowsConNuevasColumnas.map((row, idx) => ({ id: idx, cells: row }))
        
        setTableHeaders(headersConNuevasColumnas)
        setTableData(dataConIds)
        // Guardar una copia profunda de los datos originales
        setTableDataOriginal(JSON.parse(JSON.stringify(dataConIds)))
        
        // Cargar grupos de artículos
        setLoadingGrupos(true)
        
        const gruposResponse = await getGruposArticulos()
        
        if (gruposResponse && gruposResponse.grupo_articulos) {
          setGruposArticulos(gruposResponse.grupo_articulos)
        }
        setLoadingGrupos(false)
        
        setShowTableModal(true)
        
        // Validar materiales existentes apenas se muestra la tabla
        await validarMaterialesExistentes(dataConIds, headersConNuevasColumnas)
      } else {
        toast.error('Error al traducir los repuestos')
      }
    } catch (error) {
      console.error('Error en handleContinuarConMarca:', error)
      toast.error('Error al traducir los repuestos')
    }
  }

  const handleCellChange = (rowId, cellIndex, value) => {
    setTableData(prevData =>
      prevData.map(row =>
        row.id === rowId
          ? { ...row, cells: row.cells.map((cell, idx) => idx === cellIndex ? value : cell) }
          : row
      )
    )
  }

  const guardarItems = async (itemsParaGuardar) => {
    try {
      const response = await postCrearItems(itemsParaGuardar)
      
      if (response && response.creado) {
        toast.success('Items creados exitosamente')
        
        // Recargar la lista de materiales del catálogo
        if (catalogoId) {
          const itemsResponse = await getItemsByCatalogoId(catalogoId)
          if (itemsResponse && itemsResponse.items) {
            setMateriales(itemsResponse.items)
          }
        }
        
        // Cerrar modales y limpiar estados
        setShowTableModal(false)
        setShowConfirmModal(false)
        setTableData([])
        setTableHeaders([])
        setTableDataOriginal([])
        setImagenes([])
        setInstrucciones('')
        setGsUrlsImagenes([])
        setItemsFiltrados([])
        setNpfExistentes([])
        setRowMetadata({})
      } else {
        toast.error('Error al crear los items. Por favor, intenta nuevamente.')
      }
    } catch (error) {
      console.error('Error al guardar items:', error)
      toast.error('Error al crear los items. Por favor, intenta nuevamente.')
    }
  }

  const handleSaveTable = async () => {
    // Encontrar los índices de las columnas con los nuevos nombres
    const textoBreveEsIdx = tableHeaders.findIndex(h => h === 'TEXTO BREVE')
    const grupoArticuloIdx = tableHeaders.findIndex(h => h.toLowerCase().includes('grupo') && h.toLowerCase().includes('articulo'))
    const parteNumeroIdx = tableHeaders.findIndex(h => h.toLowerCase().includes('nro antiguo') || h.toLowerCase().includes('npf'))
    const textoBreveEnIdx = tableHeaders.findIndex(h => h.toLowerCase().includes('ingles'))
    const textoChimoIdx = tableHeaders.findIndex(h => h.toLowerCase().includes('chino'))
    const motivoIdx = tableHeaders.findIndex(h => h.toLowerCase().includes('motivo'))
    const jerarquiaIdx = tableHeaders.findIndex(h => h.toLowerCase().includes('jerarquia') && !h.toLowerCase().includes('estructura'))
    const estructuraSugeridaIdx = tableHeaders.findIndex(h => h.toLowerCase().includes('estructura'))
    const calificacionIdx = tableHeaders.findIndex(h => h.toLowerCase() === 'calificacion')
    const fobIdx = tableHeaders.findIndex(h => h.toLowerCase() === 'fob')
    const cantidadIdx = tableHeaders.findIndex(h => h.toLowerCase() === 'cantidad')

    if (calificacionIdx !== -1) {
      const filaSinValorar = tableData.find((row) => {
        const npfCell = parteNumeroIdx !== -1 ? row.cells[parteNumeroIdx] : ''
        const npf = npfCell && String(npfCell).trim() !== '' ? npfCell : ''
        const esExistente = Array.isArray(npfExistentes) && npfExistentes.includes(npf)
        if (esExistente) return false
        const cal = row.cells[calificacionIdx]
        return cal !== '0' && cal !== '1'
      })
      if (filaSinValorar) {
        alert(
          'Debes valorar cada material nuevo  antes de guardar.'
        )
        return
      }
    }
    
    // Construir el array de objetos
    const jsonData = tableData.map(row => {
      // Buscar el valor original de texto_breve_es
      const rowOriginal = tableDataOriginal.find(r => r.id === row.id)
      const textoBreveEsOriginal = rowOriginal && textoBreveEsIdx !== -1 
        ? rowOriginal.cells[textoBreveEsIdx] 
        : (textoBreveEsIdx !== -1 ? row.cells[textoBreveEsIdx] : "")

      const name = JSON.parse(sessionStorage.getItem('userInfo')) || null

      const meta = rowMetadata[row.id] || {}
      
      return {
        catalogo_id: catalogoId || null,
        usuario_id: userId || null,
        tipo_material: 'ZROH',
        texto_chino: textoChimoIdx !== -1 ? row.cells[textoChimoIdx] : "",
        texto_breve_es: textoBreveEsIdx !== -1 ? row.cells[textoBreveEsIdx] : "",
        texto_breve_es_original_ia: textoBreveEsOriginal,
        texto_breve_en: textoBreveEnIdx !== -1 ? row.cells[textoBreveEnIdx] : "",
        npf: parteNumeroIdx !== -1 ? row.cells[parteNumeroIdx] : "",
        grupo_articulo: (() => {
          if (grupoArticuloIdx === -1) return ""
          const valor = row.cells[grupoArticuloIdx] || ""
          if (valor.includes(' - ')) {
            return valor.split(' - ')[0].trim()
          }
          return valor
        })(),
        material_vigente: "ACTIVO",
        peso_bruto: 1,
        unidad_peso: "G",
        peso_neto: 1,
        volumen: 1,
        unidad_volumen: "CM3",
        tamanio_dimension: "17.84 x 17.84 x 9.55 MM",
        motivo: motivoIdx !== -1 ? row.cells[motivoIdx] : "NUEVA REFERENCIA",
        jerarquia: jerarquiaIdx !== -1 ? row.cells[jerarquiaIdx] : "",
        categoria_snapshot: meta.categoria_snapshot || '',
        subcategoria_snapshot: meta.subcategoria_snapshot || '',
        estructura_original: meta.estructura_original || '',
        estructura_sugerida: estructuraSugeridaIdx !== -1 ? (row.cells[estructuraSugeridaIdx] || '') : '',
        calificacion_sugerida: calificacionIdx !== -1 && row.cells[calificacionIdx] !== ''
          ? parseInt(row.cells[calificacionIdx], 10)
          : null,
        fob: fobIdx !== -1 && row.cells[fobIdx] ? parseFloat(row.cells[fobIdx]) || 0 : 0,
        cantidad: cantidadIdx !== -1 ? (parseInt(row.cells[cantidadIdx], 10) || 0) : 0,
        nombre_proveedor: nombreProveedor,
        codigo_proveedor: codigoProveedor,
        marca: marcaSeleccionada,
        pedido_inicial: 1,
        solicitado_por: name?.nombre ? name.nombre : '-',
        sap_asignado: '',
        gs_urls: Array.isArray(gsUrlsImagenes) ? gsUrlsImagenes : [],
      }
    })

    // Filtrar solo los materiales nuevos (los que NO están en npfExistentes)
    const itemsParaGuardar = jsonData.filter(item => {
      const npf = item.npf && item.npf.trim() !== '' ? item.npf : ''
      return !(Array.isArray(npfExistentes) && npfExistentes.includes(npf))
    })

    // Si no hay materiales nuevos para guardar
    if (itemsParaGuardar.length === 0) {
      alert('No hay materiales nuevos para guardar. Todos los materiales ya existen.')
      return
    }

    // Guardar solo los materiales nuevos
    await guardarItems(itemsParaGuardar)
  }

  const handleConfirmarGuardado = async () => {
    setShowConfirmModal(false)
    await guardarItems(itemsFiltrados)
    setNpfExistentes([])
  }

  const handleCancelarGuardado = () => {
    setShowConfirmModal(false)
    setItemsFiltrados([])
    setMaterialesExistentes(0)
    setMaterialesNuevos(0)
    setNpfExistentes([])
  }

  const handleCerrarModalTabla = () => {
    setShowTableModal(false)
    setNpfExistentes([])
  }

  return (
    <div className="catalogo-detalle-container">
      {/* Header */}
      <div className="catalogo-detalle-header">
        <button
          type="button"
          className="catalogo-detalle-back-btn"
          onClick={onVolver}
        >
          <FiArrowLeft />
          Volver a proveedores
        </button>
        <h2 className="catalogo-detalle-title">
          {nombreProveedor} - {getNombreArchivo(catalogo.path)} 
        </h2>
        <h3 className="catalogo-detalle-subtitle">
          Grupo compras -  {catalogoInfoData?.grupo_compras}
        </h3>
      </div>

      {/* Content */}
      <div className="catalogo-detalle-content">
        {/* Izquierda - Preview PDF */}
        <div className="catalogo-detalle-left">
          {/* Controles del PDF */}
          <div className="catalogo-pdf-controls">
            <div className="catalogo-zoom-controls">
              <button 
                type="button" 
                className="catalogo-control-btn"
                onClick={zoomOut}
              >
                <FiZoomOut />
              </button>
              <span className="catalogo-zoom-level">{Math.round(scale * 100)}%</span>
              <button 
                type="button" 
                className="catalogo-control-btn"
                onClick={zoomIn}
              >
                <FiZoomIn />
              </button>
            </div>

            {numPages > 0 && (
              <div className="catalogo-page-controls">
                <button
                  type="button"
                  className="catalogo-control-btn"
                  onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                  disabled={currentPage === 1}
                >
                  Anterior
                </button>
                <div className="catalogo-page-info-wrapper">
                  <span className="catalogo-page-info">
                    Página {currentPage} de {numPages}
                  </span>
                  <form onSubmit={handlePageInputSubmit} className="catalogo-page-jump">
                    <input
                      type="number"
                      min="1"
                      max={numPages}
                      value={pageInput}
                      onChange={handlePageInputChange}
                      placeholder="Ir a..."
                      className="catalogo-page-input"
                    />
                  </form>
                </div>
                <button
                  type="button"
                  className="catalogo-control-btn"
                  onClick={() => setCurrentPage((p) => Math.min(numPages, p + 1))}
                  disabled={currentPage === numPages}
                >
                  Siguiente
                </button>
                <button
                  type="button"
                  className="catalogo-control-btn catalogo-thumbnails-btn"
                  onClick={() => setShowThumbnails(true)}
                  title="Ver todas las páginas"
                >
                  <FiGrid />
                </button>
              </div>
            )}
          </div>

          {/* Visor de PDF con selección */}
          <div className="catalogo-pdf-viewer">
            <SelectionArea onCapture={handleSnippet}>
              <Document 
                file={catalogo.signed_url} 
                onLoadSuccess={onDocumentLoadSuccess}
                loading={<div style={{ color: 'white', padding: '20px' }}>Cargando PDF...</div>}
                error={<div style={{ color: 'white', padding: '20px' }}>Error al cargar el PDF</div>}
                options={pdfjsOptions}
              >
                <Page 
                  pageNumber={currentPage} 
                  scale={scale}
                  renderTextLayer
                  renderAnnotationLayer
                  className="catalogo-pdf-page"
                  loading={<div style={{ color: 'white', padding: '20px' }}>Cargando página...</div>}
                />
              </Document>
            </SelectionArea>
          </div>
        </div>

        {/* Derecha - Panel de Información */}
        <div className="catalogo-detalle-right">
          {/* Tabla */}
          <div className="catalogo-detalle-section">
            <h3 className="catalogo-section-title">
              Materiales {materiales.length > 0 && `(${materiales.length})`}
            </h3>
            <div className="catalogo-detalle-table-container">
              {loadingMateriales ? (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Cargando materiales...</span>
                  </div>
                  <p style={{ marginTop: '10px', color: '#666' }}>Cargando materiales...</p>
                </div>
              ) : materiales.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                  <p>No hay materiales disponibles para este catálogo</p>
                </div>
              ) : (
                <table className="catalogo-detalle-table">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>NPF</th>
                      <th>Descripción ES</th>
                      <th>Texto Chino</th>
                      <th>Marca</th>
                      <th>Jerarquía</th>
                    </tr>
                  </thead>
                  <tbody>
                    {materiales.map((material, index) => (
                      <tr key={material.id || index}>
                        <td>{material.id || '-'}</td>
                        <td>{material.npf || '-'}</td>
                        <td>{material.texto_breve_es || material.descripcion || '-'}</td>
                        <td>{material.texto_chino || '-'}</td>
                        <td>{material.marca || '-'}</td>
                        <td style={{ fontSize: '11px', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={material.jerarquia || '-'}>
                          {material.jerarquia || '-'}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>

          {/* Sección Fotos del Material */}
          <div className="catalogo-detalle-section">
            <h3 className="catalogo-section-title">
              Fotos ({imagenes.length}/4)
            </h3>
            <p className="catalogo-section-subtitle">
              Sube imágenes o crea capturas arrastrando el mouse sobre el PDF
            </p>
            <div className="catalogo-imagenes-grid">
              {imagenes.map((imagen) => (
                <div key={imagen.id} className="catalogo-imagen-card">
                  <div className="catalogo-imagen-preview-wrapper">
                    <img
                      src={imagen.preview}
                      alt={`Preview ${imagen.id}`}
                      className="catalogo-preview-img"
                    />
                    {imagen.isScreenshot && (
                      <span className="catalogo-screenshot-badge">Captura</span>
                    )}
                    <div className="catalogo-imagen-actions-overlay">
                      <button
                        type="button"
                        className="catalogo-action-btn catalogo-action-btn-preview"
                        onClick={() => previewImagen(imagen)}
                        title="Previsualizar"
                      >
                        <FiEye />
                      </button>
                      <button
                        type="button"
                        className="catalogo-action-btn catalogo-action-btn-delete"
                        onClick={() => deleteImagen(imagen.id)}
                        title="Eliminar"
                      >
                        <FiTrash2 />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
              
              {imagenes.length < 4 && (
                <div className="catalogo-imagen-upload">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImagenChange}
                    className="catalogo-file-input"
                    id="upload-imagen"
                  />
                  <label htmlFor="upload-imagen" className="catalogo-file-label">
                    <div className="catalogo-upload-placeholder">
                      <FiUpload className="catalogo-upload-icon" />
                      <span>Subir imagen</span>
                    </div>
                  </label>
                </div>
              )}
            </div>
          </div>

          {/* Instrucciones adicionales */}
          <div className="catalogo-detalle-section">
            <h3 className="catalogo-section-title">Instrucciones adicionales</h3>
            <textarea
              className="catalogo-textarea"
              placeholder="Proporciona contexto o instrucciones especiales sobre las imágenes subidas"
              value={instrucciones}
              onChange={(e) => setInstrucciones(e.target.value)}
              rows={4}
            />
          </div>

          {/* Botón */}
          <div className="catalogo-detalle-actions">
            <button 
              type="button" 
              className="catalogo-submit-btn"
              onClick={handleSubmit}
            >
              subir
            </button>
          </div>
        </div>
      </div>

      {/* Modal de Preview de Imagen */}
      {previewImage && (
        <div 
          className="catalogo-preview-modal" 
          onClick={closePreview}
          onKeyDown={(e) => e.key === 'Escape' && closePreview()}
          role="button"
          aria-label="Cerrar modal"
          tabIndex={0}
        >
          <div 
            className="catalogo-preview-modal-content" 
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            role="button"
            tabIndex={0}
          >
            <button
              type="button"
              className="catalogo-preview-close"
              onClick={closePreview}
              aria-label="Cerrar previsualización"
            >
              ×
            </button>
            <img
              src={previewImage.preview}
              alt="Preview ampliado"
              className="catalogo-preview-modal-img"
            />
            <div className="catalogo-preview-modal-info">
              <span>
                {previewImage.isScreenshot ? 'Captura de pantalla' : 'Imagen subida'}
              </span>
              <span className="catalogo-preview-modal-time">
                {new Date(previewImage.timestamp).toLocaleString()}
              </span>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Tabla Editable */}
      {showTableModal && (
        <div 
          className="catalogo-table-modal" 
          onClick={handleCerrarModalTabla}
          onKeyDown={(e) => e.key === 'Escape' && handleCerrarModalTabla()}
          role="button"
          aria-label="Cerrar modal de tabla"
          tabIndex={0}
        >
          <div 
            className="catalogo-table-modal-content" 
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            role="button"
            tabIndex={0}
          >
            <div className="catalogo-table-modal-header">
              <h3>Editar Traducción de Repuestos</h3>
              <button
                type="button"
                className="catalogo-preview-close"
                onClick={handleCerrarModalTabla}
                aria-label="Cerrar modal"
              >
                ×
              </button>
            </div>
            <div className="catalogo-table-modal-body">
              <div className="catalogo-editable-table-wrapper">
                <table className="catalogo-editable-table">
                  <thead>
                    <tr>
                      {tableHeaders.map((header, idx) => (
                        <th key={idx}>{header}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((row) => {
                      // Encontrar el índice de la columna NPF
                      const parteNumeroIdx = tableHeaders.findIndex(h => 
                        h.toLowerCase().includes('nro antiguo') || h.toLowerCase().includes('npf')
                      )
                      // Obtener el NPF de esta fila
                      const npfFila = parteNumeroIdx !== -1 ? row.cells[parteNumeroIdx] : ''
                      // Verificar si este NPF está en la lista de existentes
                      const esExistente = Array.isArray(npfExistentes) && npfExistentes.includes(npfFila)
                      
                      return (
                        <tr 
                          key={row.id}
                          style={{
                            backgroundColor: esExistente ? '#ffebee' : 'transparent',
                            borderLeft: esExistente ? '4px solid #f44336' : 'none'
                          }}
                          title={esExistente ? 'Este material ya existe en el sistema' : ''}
                        >
                          {row.cells.map((cell, cellIdx) => {
                            const headerName = tableHeaders[cellIdx]?.toLowerCase() || ''
                            const isMotivo = headerName.includes('motivo')
                            const isJerarquia = headerName.includes('jerarquia') && !headerName.includes('estructura')
                            const isGrupoArticulo = headerName.includes('grupo') && headerName.includes('articulo')
                            const isEstructuraSugerida = headerName.includes('estructura')
                            const isCalificacion = headerName === 'calificacion'
                            const isFob = headerName === 'fob'
                            const isCantidad = headerName === 'cantidad'
                            const isTextoBreveMax40 = headerName.includes('texto breve') || headerName.includes('texto en chino')
                            
                            return (
                              <td key={cellIdx}>
                              {isCalificacion ? (
                                <div className="catalogo-calificacion-thumb-row" style={{ justifyContent: 'center' }}>
                                  <button
                                    type="button"
                                    className={`catalogo-thumb-btn ${cell === '1' ? 'catalogo-thumb-btn--active-like' : ''}`}
                                    onClick={() => handleCellChange(row.id, cellIdx, cell === '1' ? '' : '1')}
                                    title="Adecuado"
                                  >
                                    <FiThumbsUp />
                                  </button>
                                  <button
                                    type="button"
                                    className={`catalogo-thumb-btn ${cell === '0' ? 'catalogo-thumb-btn--active-dislike' : ''}`}
                                    onClick={() => handleCellChange(row.id, cellIdx, cell === '0' ? '' : '0')}
                                    title="No adecuado"
                                  >
                                    <FiThumbsDown />
                                  </button>
                                </div>
                              ) : isEstructuraSugerida ? (
                                <input
                                  type="text"
                                  value={cell}
                                  onChange={(e) => handleCellChange(row.id, cellIdx, e.target.value)}
                                  className="catalogo-table-input"
                                  placeholder="Estructura sugerida"
                                  style={{ minWidth: '220px' }}
                                />
                              ) : isJerarquia ? (
                                <div className="catalogo-table-readonly" style={{ padding: '8px', fontSize: '13px', color: '#333' }}>
                                  {cell || '-'}
                                </div>
                              ) : isMotivo ? (
                                <select
                                  value={cell}
                                  onChange={(e) => handleCellChange(row.id, cellIdx, e.target.value)}
                                  className="catalogo-table-input"
                                >
                                  <option value="NUEVA REFERENCIA">NUEVA REFERENCIA</option>
                                </select>
                              ) : isGrupoArticulo ? (
                                <>
                                  <input
                                    type="text"
                                    value={(() => {
                                      // Si el valor es solo un ID, buscar el grupo para mostrar "ID - NOMBRE"
                                      if (cell) {
                                        const grupo = gruposArticulos.find(g => 
                                          g.grupo_articulo === cell || g.grupo_articulos === cell
                                        )
                                        if (grupo) {
                                          const id = grupo.grupo_articulo || grupo.grupo_articulos
                                          const nombre = grupo.descripcion_grupo_aticulo || grupo.descripcion_grupo_articulo || ''
                                          return `${id} - ${nombre}`
                                        }
                                        // Si ya tiene formato "ID - NOMBRE", mantenerlo
                                        if (cell.includes(' - ')) {
                                          return cell
                                        }
                                      }
                                      return cell || ''
                                    })()}
                                    onChange={(e) => {
                                      const inputValue = e.target.value
                                      // Si el usuario selecciona del datalist o escribe, extraer solo el ID
                                      if (inputValue.includes(' - ')) {
                                        const id = inputValue.split(' - ')[0].trim()
                                        handleCellChange(row.id, cellIdx, id)
                                      } else {
                                        // Si escribe directamente, buscar coincidencia
                                        const grupoEncontrado = gruposArticulos.find(g => {
                                          const id = g.grupo_articulo || g.grupo_articulos
                                          const nombre = g.descripcion_grupo_aticulo || g.descripcion_grupo_articulo || ''
                                          return id.toLowerCase().includes(inputValue.toLowerCase()) ||
                                                 nombre.toLowerCase().includes(inputValue.toLowerCase())
                                        })
                                        if (grupoEncontrado) {
                                          const id = grupoEncontrado.grupo_articulo || grupoEncontrado.grupo_articulos
                                          const nombre = grupoEncontrado.descripcion_grupo_aticulo || grupoEncontrado.descripcion_grupo_articulo || ''
                                          if (inputValue === `${id} - ${nombre}`) {
                                            handleCellChange(row.id, cellIdx, id)
                                          } else {
                                            handleCellChange(row.id, cellIdx, inputValue)
                                          }
                                        } else {
                                          handleCellChange(row.id, cellIdx, inputValue)
                                        }
                                      }
                                    }}
                                    onBlur={(e) => {
                                      // Al perder el foco, si tiene formato "ID - NOMBRE", extraer solo el ID
                                      const inputValue = e.target.value
                                      if (inputValue.includes(' - ')) {
                                        const id = inputValue.split(' - ')[0].trim()
                                        handleCellChange(row.id, cellIdx, id)
                                      }
                                    }}
                                    className="catalogo-table-input"
                                    disabled={loadingGrupos}
                                    list={`grupo-articulos-list-${row.id}`}
                                    placeholder="Escribe para buscar..."
                                  />
                                  <datalist id={`grupo-articulos-list-${row.id}`}>
                                    {gruposArticulos.map((grupo, index) => {
                                      const id = grupo.grupo_articulo || grupo.grupo_articulos
                                      const nombre = grupo.descripcion_grupo_aticulo || grupo.descripcion_grupo_articulo || ''
                                      const displayValue = `${id} - ${nombre}`
                                      return (
                                        <option key={`${id}-${index}`} value={displayValue} data-id={id} />
                                      )
                                    })}
                                  </datalist>
                                </>
                              ) : isFob ? (
                                <input
                                  type="number"
                                  step="0.01"
                                  min="0"
                                  value={cell}
                                  onChange={(e) => handleCellChange(row.id, cellIdx, e.target.value)}
                                  className="catalogo-table-input"
                                  placeholder="0.00"
                                />
                              ) : isCantidad ? (
                                <input
                                  type="number"
                                  min="0"
                                  step="1"
                                  value={cell ?? '0'}
                                  onChange={(e) => handleCellChange(row.id, cellIdx, e.target.value)}
                                  className="catalogo-table-input"
                                  placeholder="0"
                                />
                              ) : (
                                <input
                                  type="text"
                                  value={cell}
                                  onChange={(e) => handleCellChange(row.id, cellIdx, isTextoBreveMax40 ? e.target.value.slice(0, 40) : e.target.value)}
                                  className="catalogo-table-input"
                                  maxLength={isTextoBreveMax40 ? 40 : undefined}
                                  placeholder={isTextoBreveMax40 ? `Máx. 40 (${(cell || '').length}/40)` : undefined}
                                />
                              )}
                            </td>
                          )
                        })}
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="catalogo-table-modal-footer">
              <button
                type="button"
                className="catalogo-table-btn catalogo-table-btn-cancel"
                onClick={handleCerrarModalTabla}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="catalogo-table-btn catalogo-table-btn-save"
                onClick={handleSaveTable}
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Thumbnails */}
      {showThumbnails && (
        <div 
          className="catalogo-thumbnails-modal" 
          onClick={() => setShowThumbnails(false)}
          onKeyDown={(e) => e.key === 'Escape' && setShowThumbnails(false)}
          role="button"
          aria-label="Cerrar vista de miniaturas"
          tabIndex={0}
        >
          <div 
            className="catalogo-thumbnails-modal-content" 
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            role="button"
            tabIndex={0}
          >
            <div className="catalogo-thumbnails-header">
              <h3>Todas las páginas ({numPages})</h3>
              <button
                type="button"
                className="catalogo-preview-close"
                onClick={() => setShowThumbnails(false)}
                aria-label="Cerrar vista de miniaturas"
              >
                ×
              </button>
            </div>
            <div className="catalogo-thumbnails-grid">
              {Array.from(new Array(numPages), (el, index) => (
                <div
                  key={`thumb_${index + 1}`}
                  className={`catalogo-thumbnail-item ${
                    currentPage === index + 1 ? 'active' : ''
                  }`}
                  onClick={() => goToPage(index + 1)}
                >
                  <div className="catalogo-thumbnail-page-wrapper">
                    <Document file={catalogo.signed_url} options={pdfjsOptions}>
                      <Page
                        pageNumber={index + 1}
                        height={220}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                      />
                    </Document>
                  </div>
                  <div className="catalogo-thumbnail-label">
                    Página {index + 1}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Modal de Selección de Marcas */}
      {showMarcasModal && (
        <div 
          className="catalogo-table-modal" 
          onClick={() => !loadingMarcas && setShowMarcasModal(false)}
          onKeyDown={(e) => e.key === 'Escape' && !loadingMarcas && setShowMarcasModal(false)}
          role="button"
          aria-label="Cerrar modal de marcas"
          tabIndex={0}
        >
          <div 
            className="catalogo-table-modal-content" 
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            role="button"
            tabIndex={0}
            style={{ maxWidth: '500px' }}
          >
            <div className="catalogo-table-modal-header">
              <h3>Seleccionar Marca</h3>
              {!loadingMarcas && (
                <button
                  type="button"
                  className="catalogo-preview-close"
                  onClick={() => setShowMarcasModal(false)}
                  aria-label="Cerrar modal"
                >
                  ×
                </button>
              )}
            </div>
            <div className="catalogo-table-modal-body" style={{ minHeight: '200px' }}>
              {loadingMarcas ? (
                <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                  <div className="spinner-border" role="status" style={{ width: '3rem', height: '3rem' }}>
                    <span className="sr-only">Cargando marcas...</span>
                  </div>
                  <p style={{ marginTop: '20px', color: '#666', fontSize: '14px' }}>Cargando marcas...</p>
                </div>
              ) : (
                <div style={{ padding: '10px 0' }}>
                  <label htmlFor="select-marca" style={{ display: 'block', marginBottom: '10px', fontWeight: '500', color: '#333' }}>
                    Selecciona una marca:
                  </label>
                  <select
                    id="select-marca"
                    value={marcaSeleccionada || ''}
                    onChange={(e) => setMarcaSeleccionada(e.target.value)}
                    className="catalogo-table-input"
                    style={{ width: '100%', padding: '10px', fontSize: '14px' }}
                  >
                    <option value="">-- Seleccionar marca --</option>
                    {marcas.map((marca, index) => (
                      <option key={marca.id || index} value={marca.nombre}>
                        {marca.nombre}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </div>
            {!loadingMarcas && (
              <div className="catalogo-table-modal-footer">
                <button
                  type="button"
                  className="catalogo-table-btn catalogo-table-btn-cancel"
                  onClick={() => setShowMarcasModal(false)}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className="catalogo-table-btn catalogo-table-btn-save"
                  onClick={handleContinuarConMarca}
                  disabled={!marcaSeleccionada}
                >
                  Siguiente
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Modal de Confirmación de Materiales Existentes */}
      {showConfirmModal && (
        <div 
          className="catalogo-table-modal" 
          onClick={() => setShowConfirmModal(false)}
          onKeyDown={(e) => e.key === 'Escape' && setShowConfirmModal(false)}
          role="button"
          aria-label="Cerrar modal de confirmación"
          tabIndex={0}
        >
          <div 
            className="catalogo-table-modal-content" 
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            role="button"
            tabIndex={0}
            style={{ maxWidth: '500px' }}
          >
            <div className="catalogo-table-modal-header">
              <h3>Materiales Existentes Detectados</h3>
              <button
                type="button"
                className="catalogo-preview-close"
                onClick={() => setShowConfirmModal(false)}
                aria-label="Cerrar modal"
              >
                ×
              </button>
            </div>
            <div className="catalogo-table-modal-body catalogo-confirm-materiales-body">
              <div className="catalogo-confirm-materiales-summary" role="group" aria-label="Resumen del guardado">
                <div className="catalogo-confirm-materiales-row">
                  <span className="catalogo-confirm-materiales-label">Materiales ya existentes</span>
                  <span className="catalogo-confirm-materiales-value">{materialesExistentes}</span>
                </div>
                <div className="catalogo-confirm-materiales-row">
                  <span className="catalogo-confirm-materiales-label">Materiales nuevos a guardar</span>
                  <span className="catalogo-confirm-materiales-value">{materialesNuevos}</span>
                </div>
              </div>
              <p className="catalogo-confirm-materiales-pregunta">
                ¿Desea continuar con el guardado de los {materialesNuevos} materiales nuevos?
              </p>
            </div>
            <div className="catalogo-table-modal-footer">
              <button
                type="button"
                className="catalogo-table-btn catalogo-table-btn-cancel"
                onClick={handleCancelarGuardado}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="catalogo-table-btn catalogo-table-btn-save"
                onClick={handleConfirmarGuardado}
              >
                Continuar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default CatalogoDetalle

